(function() {
  'use strict';
  const SVG_NS = 'http://www.w3.org/2000/svg';

  const dataEl = document.getElementById('ghostfit-personalization-data');
  const colorsEl = document.getElementById('ghostfit-school-colors');
  if (!dataEl || !colorsEl) return;

  let config, schoolColors;
  try {
    config = JSON.parse(dataEl.textContent);
    schoolColors = JSON.parse(colorsEl.textContent);
  } catch (e) {
    console.error('[personalization] failed to parse data blobs', e);
    return;
  }
  if (!config) return;

  // Store-wide name/number face from collection metafield
  // ghostfit.personalization_font (injected on #ghostfit-school-colors).
  // One id for every location. Not a shopper picker — availableFonts stays
  // length 1. Fallback is the blob's availableFonts[0] (usually athletic-block).
  const STORE_NAME_NUMBER_FONTS = {
    'athletic-block': true,
    script: true,
    zeroathletics: true,
    modern: true
  };
  function resolvePreviewFont(zone) {
    const storeFont = String((schoolColors && schoolColors.font) || '').trim();
    if (STORE_NAME_NUMBER_FONTS[storeFont]) return storeFont;
    const fonts = zone && zone.template && zone.template.availableFonts;
    return (fonts && fonts[0]) || 'athletic-block';
  }

  // -------------------------------------------------------------------
  // Normalize the metafield shape into a zones[] array. Phase 1's
  // metafield builder always emits zones[], but existing metafields
  // written before Phase 1 ship may still carry only the legacy
  // {templateId, template, calibration} keys. Both shapes work here:
  // when zones[] is missing/empty but legacy keys exist, wrap them as
  // a single-zone array so the rest of this file only deals with zones.
  // -------------------------------------------------------------------
  let zones = Array.isArray(config.zones) ? config.zones.filter(Boolean) : [];
  if (zones.length === 0 && config.templateId && config.template && config.calibration) {
    zones = [{
      id: 'default',
      label: null,
      templateId: config.templateId,
      template: config.template,
      calibration: config.calibration
    }];
  }
  if (zones.length === 0) return;

  // -------------------------------------------------------------------
  // Defensive hydration guard. Every zone this file renders dereferences a
  // fully-expanded `zone.template` (availableFonts / defaultInkColor / fields /
  // pricing / availableInkColors — see zoneStates.map, buildZoneFields,
  // renderZoneSVG). The createproducts metafield builders hydrate that
  // server-side, but a blob written by an older/drifted service revision (or
  // hand-edited in the Shopify admin) can arrive as a RAW productConfig dump:
  // zones carrying only {templateId, mockupAnchor, fieldLayout} and no
  // `template`. Dereferencing `zone.template.availableFonts[0]` on such a zone
  // throws a TypeError at boot and takes down the ENTIRE personalize UI for the
  // product. Drop any unhydrated zone (loudly) so the remaining valid zones
  // still render; bail cleanly if none survive (product reads as
  // non-personalized rather than broken).
  function zoneTemplateUsable(zone) {
    const t = zone && zone.template;
    return !!t
      && Array.isArray(t.availableFonts) && t.availableFonts.length > 0
      && Array.isArray(t.fields)
      && Array.isArray(t.availableInkColors)
      && !!t.pricing && typeof t.pricing === 'object'
      && typeof t.defaultInkColor === 'string';
  }
  const usableZones = zones.filter(zoneTemplateUsable);
  if (usableZones.length !== zones.length) {
    const dropped = zones.filter(z => !zoneTemplateUsable(z)).map(z => (z && z.id) || '?');
    console.error(
      '[personalization] dropping zone(s) with no expanded template: ' + dropped.join(', ') +
      ' — the ghostfit.personalization metafield was written without server-side template hydration'
    );
  }
  zones = usableZones;
  if (zones.length === 0) return;

  // -------------------------------------------------------------------
  // DOM refs (only the static ones — per-zone DOM is built dynamically).
  // -------------------------------------------------------------------
  const zonesContainer = document.getElementById('pd-pers-zones');
  // Optional preview scoping: the Apple modal sets data-preview-root on
  // #pd-pers-zones so the engine drives the MODAL's preview image / overlay /
  // thumbs instead of the page gallery (which reuses #pd-main-img + .pd-thumb).
  // Unset -> everything resolves globally; the inline block + other themes are
  // byte-for-byte unchanged.
  const previewRoot = (zonesContainer && zonesContainer.dataset && zonesContainer.dataset.previewRoot)
    ? document.querySelector(zonesContainer.dataset.previewRoot) : null;
  // The blob's pricing.perLocation is the ONE per-location price, and 0 means
  // house brand. Publish it on the container so gf-storefront.js (which never
  // parses the blob) reads the same fact instead of re-deriving it from a
  // liquid attribute that can disagree with what the product actually carries.
  if (zonesContainer) {
    zonesContainer.dataset.perLocation = String(
      config.pricing && config.pricing.perLocation != null ? config.pricing.perLocation : ''
    );
  }
  const previewScope = previewRoot || document;
  let svg = previewScope.querySelector('#pd-pers-svg');
  const exactPreviewBtn = document.getElementById('pd-pers-exact-preview');
  const resetBtn = document.getElementById('pd-pers-reset');
  const priceBadge = document.getElementById('pd-pers-price');
  // CTA price element — v4 hero ships #pd-cta-price; standard themes use
  // various class-based selectors. Try a few.
  const ctaPrice = document.getElementById('pd-cta-price')
    || document.querySelector('[data-product-price]')
    || document.querySelector('.price__regular .price-item')
    || document.querySelector('.product__price [data-price]');
  const globalViewHint = document.getElementById('pd-pers-view-hint');

  // Find the main product image. The v4 hero ships #pd-main-img; for the
  // gf-personalization-block section dropped onto other product templates,
  // fall back to common Shopify product-section selectors.
  let mainImg = previewRoot
    ? (previewRoot.querySelector('[data-pers-preview-img]') || previewRoot.querySelector('#pd-main-img'))
    : document.getElementById('pd-main-img');
  if (!mainImg && !previewRoot) {
    const fallbackSelectors = [
      '.product__media-item.is-active img',
      '.product__media img',
      '.product-media img',
      '.product-gallery__main-image img',
      '.product-gallery img',
      'product-media img',
      'media-gallery img',
      'main .product img',
      'main img'
    ];
    for (const sel of fallbackSelectors) {
      const el = document.querySelector(sel);
      if (el && el.tagName === 'IMG') { mainImg = el; break; }
    }
  }

  // If no SVG overlay exists in the DOM, create one inside the main image's
  // wrapper and overlay it. The wrapper becomes position:relative so the
  // SVG can stretch over the image with absolute positioning.
  if (mainImg && !svg) {
    const wrapper = mainImg.parentElement;
    if (wrapper) {
      const wrapperStyle = window.getComputedStyle(wrapper);
      if (wrapperStyle.position === 'static') wrapper.style.position = 'relative';
      svg = document.createElementNS(SVG_NS, 'svg');
      svg.id = 'pd-pers-svg';
      svg.classList.add('pd-pers-svg');
      svg.setAttribute('viewBox', '0 0 1000 1000');
      svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
      svg.setAttribute('aria-hidden', 'true');
      // Inline styles in case the theme CSS doesn't ship .pd-pers-svg
      svg.style.position = 'absolute';
      svg.style.inset = '0';
      svg.style.width = '100%';
      svg.style.height = '100%';
      svg.style.pointerEvents = 'none';
      svg.style.zIndex = '2';
      wrapper.appendChild(svg);
    }
  }

  // Gallery thumbnails — v4 hero uses .pd-thumb; standard Shopify product
  // sections use various selectors. Try several.
  let thumbs = Array.from(previewScope.querySelectorAll('.pd-thumb'));
  if (thumbs.length === 0 && !previewRoot) {
    thumbs = Array.from(document.querySelectorAll(
      '.product__media-list button, .product__media-item button, .product-gallery__thumbnail, .gallery-thumbnail, [data-product-thumbnail]'
    ));
  }

  if (!zonesContainer || !svg) return;

  const isMultiZone = zones.length > 1;
  // Opt-in (the Apple modal sets data-auto-enable on #pd-pers-zones): start every
  // zone enabled and render no per-zone toggle. Defaults OFF, so the inline block's
  // multi-zone toggle UX is unchanged.
  const autoEnableZones = !!(zonesContainer.dataset && zonesContainer.dataset.autoEnable);
  const basePriceCents = parsePriceCents(ctaPrice && ctaPrice.textContent);

  // -------------------------------------------------------------------
  // Wisconsin hanger test only. Live stores have no wisconsinOffer on the
  // blob and keep the existing single-zone / fill-the-box engine.
  // -------------------------------------------------------------------
  // Presence tokens only (blob / field-id existence). Stacked paint ignores
  // y + fontSizePct — live metafields still ship leftover-band leftovers
  // (name 22% / number 48%) that would shrink name+number vs name-only.
  const STACKED_FIELD_LAYOUT = {
    name: { x: 0.5, y: 0.18, fontSizePct: 0.22, align: 'center' },
    number: { x: 0.5, y: 0.68, fontSizePct: 0.48, align: 'center' }
  };
  // Name+number partitions the SAME approved location box as name-only /
  // number-only: name | ~10% gap | number. Each field fit-fills its slice.
  const STACKED_PLATE_GAP = 0.10;
  const STACKED_SLICE_H = (1 - STACKED_PLATE_GAP) / 2;
  const HOODIE_BACK_BOX = { x: 0.3327, y: 0.391, w: 0.3415, h: 0.2775 };
  const SLEEVE_VIEW_LEFT_BOX = { x: 0.4416, y: 0.4194, w: 0.12, h: 0.1 };
  const SLEEVE_VIEW_RIGHT_BOX = { x: 0.4647, y: 0.4579, w: 0.1117, h: 0.0931 };
  const JOGGER_BACK_YOKE_BOX = { x: 0.378, y: 0.198, w: 0.244, h: 0.128 };
  const CLASS_LANDMARKS = {
    'hoodie-pullover': {
      back: HOODIE_BACK_BOX,
      'center-back': HOODIE_BACK_BOX,
      'full-chest': { x: 0.3327, y: 0.3000, w: 0.3415, h: 0.2775 },
      'left-chest': { x: 0.5624, y: 0.39, w: 0.1024, h: 0.0854 },
      'left-sleeve': SLEEVE_VIEW_LEFT_BOX,
      'right-sleeve': SLEEVE_VIEW_RIGHT_BOX
    },
    tee: {
      back: { x: 0.3380, y: 0.3600, w: 0.3320, h: 0.2600 },
      'full-chest': { x: 0.3380, y: 0.2900, w: 0.3320, h: 0.2600 },
      'left-chest': { x: 0.5520, y: 0.3050, w: 0.1100, h: 0.0900 },
      'left-sleeve': SLEEVE_VIEW_LEFT_BOX,
      'right-sleeve': SLEEVE_VIEW_RIGHT_BOX
    },
    polo: {
      back: { x: 0.3400, y: 0.3550, w: 0.3280, h: 0.2500 },
      'full-chest': { x: 0.3400, y: 0.2850, w: 0.3280, h: 0.2500 },
      'left-chest': { x: 0.5450, y: 0.2930, w: 0.0910, h: 0.0710 },
      'left-sleeve': SLEEVE_VIEW_LEFT_BOX,
      'right-sleeve': SLEEVE_VIEW_RIGHT_BOX
    },
    'quarter-zip': {
      back: { x: 0.3360, y: 0.3700, w: 0.3360, h: 0.2650 },
      'full-chest': { x: 0.3360, y: 0.2950, w: 0.3360, h: 0.2650 },
      'left-chest': { x: 0.5545, y: 0.2825, w: 0.0850, h: 0.0680 },
      'left-sleeve': SLEEVE_VIEW_LEFT_BOX,
      'right-sleeve': SLEEVE_VIEW_RIGHT_BOX
    },
    crew: {
      back: { x: 0.3340, y: 0.3800, w: 0.3380, h: 0.2700 },
      'full-chest': { x: 0.3340, y: 0.2980, w: 0.3380, h: 0.2700 },
      'left-chest': { x: 0.5460, y: 0.3120, w: 0.1120, h: 0.0920 },
      'left-sleeve': SLEEVE_VIEW_LEFT_BOX,
      'right-sleeve': SLEEVE_VIEW_RIGHT_BOX
    },
    jogger: {
      back: JOGGER_BACK_YOKE_BOX,
      'left-leg': { x: 0.5000, y: 0.4800, w: 0.1600, h: 0.2000 }
    }
  };
  const WI_VIEWS = [
    { id: 'front', label: 'Front', locations: ['left-chest', 'full-chest', 'left-leg'] },
    { id: 'back', label: 'Back', locations: ['back'] },
    { id: 'left-side', label: 'Left sleeve', locations: ['left-sleeve'] },
    { id: 'right-side', label: 'Right sleeve', locations: ['right-sleeve'] }
  ];
  const WI_LOCATION_GEO = {
    'right-sleeve': { label: 'Right Sleeve', view: 'right-side', viewImageIndex: 3 },
    back: { label: 'Back', view: 'back', viewImageIndex: 1 },
    'left-sleeve': { label: 'Left Sleeve', view: 'left-side', viewImageIndex: 2 },
    'left-chest': { label: 'Left Chest', view: 'front', viewImageIndex: 0 },
    'full-chest': { label: 'Full Chest', view: 'front', viewImageIndex: 0 },
    'left-leg': { label: 'Left Leg', view: 'front', viewImageIndex: 0 }
  };
  // Grant-verified occupancy + ink. Live metafields still have zones[] only —
  // this catalog is the dropdown / ink source of truth until attach rewrites
  // locations[] onto the blob.
  const VERIFIED_WI = [
    { handle: 'nike-swoosh-sleeve-rlegend-tee-928', styles: ['NKDX8730'], classId: 'tee', color: 'University Red', occupied: ['full-chest', 'left-sleeve'], open: ['right-sleeve', 'back'], inks: ['black', 'white', 'school-secondary'] },
    { handle: 'nike-youth-swoosh-sleeve-rlegend-tee-927', styles: ['NKDX8787'], classId: 'tee', color: 'University Red', occupied: ['full-chest', 'left-sleeve'], open: ['right-sleeve', 'back'], inks: ['black', 'white', 'school-secondary'] },
    { handle: 'mens-ultimate365-lightweight-quarter-zip-pullover-884', styles: ['A430'], classId: 'quarter-zip', color: 'Power Red', occupied: ['left-chest', 'left-sleeve'], open: ['right-sleeve', 'back'], inks: ['black', 'white', 'school-secondary'] },
    { handle: 'lane-seven-unisex-premium-pullover-1282', styles: [], classId: 'hoodie-pullover', color: 'Cardinal', occupied: ['full-chest'], open: ['right-sleeve', 'left-sleeve', 'back'], inks: ['black', 'white', 'school-secondary'] },
    { handle: 'sport-tek-posicharge-competitor-tee-4993', styles: ['ST350'], classId: 'tee', color: 'Cardinal', occupied: ['full-chest'], open: ['right-sleeve', 'left-sleeve', 'back'], inks: ['black', 'white', 'school-secondary'] },
    { handle: 'ghostfit-mens-prime-hoodie-4587', styles: ['GSF101'], classId: 'hoodie-pullover', color: 'Gray', occupied: ['full-chest'], open: ['right-sleeve', 'left-sleeve', 'back'], inks: ['black', 'white', 'school-primary', 'school-secondary'] },
    { handle: 'next-level-unisex-sueded-tee-5246', styles: ['PC61'], classId: 'tee', color: 'White', occupied: ['full-chest'], open: ['right-sleeve', 'left-sleeve', 'back'], inks: ['black', 'school-primary'] },
    { handle: 'ghostfit-mens-prime-quarter-zip-343', styles: [], classId: 'quarter-zip', color: 'Gray', occupied: ['left-chest'], open: ['right-sleeve', 'left-sleeve', 'back'], inks: ['black', 'white', 'school-primary', 'school-secondary'] },
    { handle: 'nike-dri-fit-micro-pique-2-0-polo-399', styles: ['NKDC1963'], classId: 'polo', color: 'Anthracite', occupied: ['left-chest', 'left-sleeve'], open: ['right-sleeve', 'back'], inks: ['black', 'white', 'school-primary', 'school-secondary'] },
    { handle: 'nike-womens-dri-fit-micro-pique-2-0-polo-920', styles: ['NKDC1991'], classId: 'polo', color: 'White', occupied: ['left-chest', 'left-sleeve'], open: ['right-sleeve', 'back'], inks: ['black', 'school-primary'] },
    { handle: 'adidas-mens-polo-470', styles: ['A401'], classId: 'polo', color: 'White', occupied: ['left-chest', 'left-sleeve'], open: ['right-sleeve', 'back'], inks: ['black', 'school-primary'] },
    { handle: 'adidas-womens-quarter-zip-627', styles: ['A589'], classId: 'quarter-zip', color: 'Grey', occupied: ['left-chest', 'right-sleeve'], open: ['left-sleeve', 'back'], inks: ['black', 'white', 'school-primary', 'school-secondary'] },
    { handle: 'ghostfit-womens-ultralux-hoodie-702', styles: [], classId: 'hoodie-pullover', color: 'Gray', occupied: ['full-chest'], open: ['right-sleeve', 'left-sleeve', 'back'], inks: ['black', 'white', 'school-primary', 'school-secondary'] },
    { handle: 'ghostfit-mens-tour-tee-702', styles: [], classId: 'tee', color: 'Gray', occupied: ['full-chest'], open: ['right-sleeve', 'left-sleeve', 'back'], inks: ['black', 'white', 'school-primary', 'school-secondary'] },
    { handle: 'ghostfit-womens-tour-tee-354', styles: [], classId: 'tee', color: 'Gray', occupied: ['full-chest'], open: ['right-sleeve', 'left-sleeve', 'back'], inks: ['black', 'white', 'school-primary', 'school-secondary'] },
    { handle: 'ghostfit-mens-prime-jogger-282', styles: [], classId: 'jogger', color: 'Black', occupied: ['left-leg'], open: ['back'], inks: ['white', 'school-primary', 'school-secondary'] },
    { handle: 'ghostfit-mens-ultralux-crewneck-65', styles: [], classId: 'crew', color: 'Black', occupied: ['full-chest'], open: ['right-sleeve', 'left-sleeve', 'back'], inks: ['white', 'school-primary', 'school-secondary'] },
    { handle: 'ghostfit-mens-player-polo-312', styles: [], classId: 'polo', color: 'Black', occupied: ['left-chest'], open: ['right-sleeve', 'left-sleeve', 'back'], inks: ['white', 'school-primary', 'school-secondary'] }
  ];
  // Wisconsin's own palette. ONLY the two test stores may fall back to it —
  // every other store resolves ink from its blob / #ghostfit-school-colors.
  const WI_TEST_SCHOOL_COLORS = { primary: '#C5050C', secondary: '#FFFFFF' };
  const LOCATION_OVERLAPS = {
    'full-chest': ['left-chest'],
    'full-front': ['left-chest'],
    'left-chest': ['full-chest']
  };
  function expandOccupiedIds(ids) {
    const locked = {};
    (ids || []).forEach(function (id) {
      locked[id] = true;
      (LOCATION_OVERLAPS[id] || []).forEach(function (other) { locked[other] = true; });
    });
    return locked;
  }
  function isSleeveLocationId(id) {
    return id === 'left-sleeve' || id === 'right-sleeve';
  }
  function sleeveViewBoxFor(id) {
    return id === 'left-sleeve' ? SLEEVE_VIEW_LEFT_BOX : SLEEVE_VIEW_RIGHT_BOX;
  }
  function isWrongSleeveBox(box) {
    if (!box) return true;
    if (box.x === HOODIE_BACK_BOX.x && box.y === HOODIE_BACK_BOX.y) return true;
    if (box.x === 0.3 && box.w === 0.4 && box.h === 0.45) return true;
    if (box.w >= 0.18 || box.h >= 0.18) return true;
    if (box.x < 0.28) return true;
    return false;
  }
  function approvedThemeBox(id, classId) {
    if (isSleeveLocationId(id)) {
      const landmarks = CLASS_LANDMARKS[classId] || CLASS_LANDMARKS.tee;
      const classBox = landmarks && landmarks[id];
      if (classBox && !isWrongSleeveBox(classBox)) return Object.assign({}, classBox);
      return Object.assign({}, sleeveViewBoxFor(id));
    }
    if (classId === 'jogger' && id === 'back') {
      return Object.assign({}, JOGGER_BACK_YOKE_BOX);
    }
    const landmarks = CLASS_LANDMARKS[classId] || CLASS_LANDMARKS.tee;
    return Object.assign({}, (landmarks && landmarks[id]) || HOODIE_BACK_BOX);
  }
  // One print box per location. Logo / name / number / name+number all
  // decorate inside that product print space. Never restamp CLASS_LANDMARKS
  // over a box the blob already has. Landmarks are fallback only.
  function isUsablePrintBox(box) {
    if (!box) return false;
    if (![box.x, box.y, box.w, box.h].every(function (n) {
      return typeof n === 'number' && isFinite(n);
    })) return false;
    if (box.w <= 0 || box.h <= 0) return false;
    // Generic V2 leftover — not a product override.
    if (box.x === 0.3 && box.y === 0.3 && box.w === 0.4 && box.h === 0.45) return false;
    return true;
  }
  function locationPrintBox(loc, classId) {
    const blobBox = loc && ((loc.mockupAnchor && loc.mockupAnchor.box) || loc.box);
    if (isUsablePrintBox(blobBox)) return Object.assign({}, blobBox);
    return approvedThemeBox(loc && loc.id, classId);
  }
  function wisconsinLocationRecord(id, classId) {
    const geo = WI_LOCATION_GEO[id];
    if (!geo) return null;
    const box = approvedThemeBox(id, classId);
    return {
      id: id,
      label: geo.label,
      view: geo.view,
      viewImageIndex: geo.viewImageIndex,
      classId: classId || null,
      mockupAnchor: { view: geo.view, viewImageIndex: geo.viewImageIndex, box: Object.assign({}, box) },
      fieldLayout: {
        name: Object.assign({}, STACKED_FIELD_LAYOUT.name),
        number: Object.assign({}, STACKED_FIELD_LAYOUT.number)
      }
    };
  }
  function lookupVerifiedWisconsin(handle, style) {
    const h = String(handle || '').trim().toLowerCase().replace(/^\/+|\/+$/g, '');
    const s = String(style || '').trim().toUpperCase();
    for (let i = 0; i < VERIFIED_WI.length; i++) {
      const row = VERIFIED_WI[i];
      if (h && (h === row.handle || h.indexOf(row.handle) !== -1)) return row;
    }
    if (s) {
      for (let i = 0; i < VERIFIED_WI.length; i++) {
        if ((VERIFIED_WI[i].styles || []).indexOf(s) !== -1) return VERIFIED_WI[i];
      }
    }
    return null;
  }
  function readGarmentFromPdp() {
    const swatch = document.querySelector('#swatch-row .swatch.is-active');
    const hex = (swatch && (swatch.dataset.hex || '').trim()) || '';
    const name = ((document.getElementById('pd-color-name') || {}).textContent || '').trim();
    return { family: name.toLowerCase().replace(/\s+/g, '-'), hex: hex, name: name };
  }
  function synthesizeWisconsinOffer(locations) {
    const locs = (locations && locations.length) ? locations : zones.map(z => {
      const cal = z.calibration || {};
      const box = (cal.mockupAnchor && cal.mockupAnchor.box) || HOODIE_BACK_BOX;
      return {
        id: z.id || 'back',
        label: z.label || prettyViewLabel(cal.view) || 'Back',
        view: cal.view || 'back',
        viewImageIndex: cal.viewImageIndex,
        mockupAnchor: { view: cal.view || 'back', viewImageIndex: cal.viewImageIndex, box: box },
        fieldLayout: cal.fieldLayout && cal.fieldLayout.name && cal.fieldLayout.number
          ? cal.fieldLayout
          : { name: Object.assign({}, STACKED_FIELD_LAYOUT.name), number: Object.assign({}, STACKED_FIELD_LAYOUT.number) }
      };
    });
    return {
      scope: 'wisconsin-hanger-test',
      addon: 10,
      defaultType: 'name-number',
      types: config.types || [
        { id: 'name', label: 'Name', fields: ['name'] },
        { id: 'number', label: 'Number', fields: ['number'] },
        { id: 'name-number', label: 'Name + Number', fields: ['name', 'number'] }
      ],
      locations: locs,
      occupancy: config.occupancy || [],
      garmentColor: config.garmentColor || readGarmentFromPdp(),
      schoolColors: config.schoolColors || schoolColors || (wiStoreFlag ? Object.assign({}, WI_TEST_SCHOOL_COLORS) : null),
      ink: config.ink || null,
      brand: ''
    };
  }
  // Two flags, deliberately different. data-wisconsin is emitted ONLY for the
  // two Wisconsin hanger-test store ids (gf-personalize-modal.liquid's
  // wisconsin_hanger_test), so it is the only thing allowed to unlock the
  // VERIFIED_WI catalog. The .is-wisconsin class is WIDER — hanger_mode sets it
  // for any store whose blob carries locations[] — so it may switch the hanger
  // UI on, but it must never import Wisconsin's inks / occupancy: a new store's
  // GSF101 hoodie (ghostfit-mens-prime-hoodie-4588) was matching Wisconsin's row
  // by STYLE and inheriting its #C5050C ink and its occupied locations.
  const wiStoreFlag = !!(zonesContainer.dataset && zonesContainer.dataset.wisconsin === 'true');
  const wiFlag = wiStoreFlag || !!(document.querySelector('.gf-pz-modal.is-wisconsin'));
  const productHandle = (zonesContainer.dataset && zonesContainer.dataset.handle)
    || window.GHOSTFIT_PRODUCT_HANDLE
    || '';
  const productStyle = (zonesContainer.dataset && zonesContainer.dataset.style) || '';
  // Opted-in stores get locations[] / ink / occupancy from their OWN blob; only
  // the two test stores fall back to the hand-verified catalog.
  const verifiedWi = wiStoreFlag ? lookupVerifiedWisconsin(productHandle, productStyle) : null;
  const blobLocations = (config.wisconsinOffer && config.wisconsinOffer.locations)
    || config.locations
    || null;
  const hasBlobLocations = Array.isArray(blobLocations) && blobLocations.length > 0;
  const wiOffer = (config.wisconsinOffer && config.wisconsinOffer.scope === 'wisconsin-hanger-test')
    ? config.wisconsinOffer
    : (wiFlag || hasBlobLocations || verifiedWi
      ? synthesizeWisconsinOffer(hasBlobLocations ? blobLocations : null)
      : null);
  if (wiOffer) {
    if (hasBlobLocations) {
      wiOffer.locations = blobLocations;
    } else if (verifiedWi) {
      wiOffer.locations = verifiedWi.open.map(function (id) {
        return wisconsinLocationRecord(id, verifiedWi.classId || (wiOffer && wiOffer.classId));
      }).filter(Boolean);
    }
    if (verifiedWi && !wiOffer.classId) wiOffer.classId = verifiedWi.classId;
    if (!wiOffer.views) wiOffer.views = (config.views || {});
    const occIds = (wiOffer.occupancy || []).map(function (o) { return o.id; })
      .concat((verifiedWi && verifiedWi.occupied) || []);
    const overlapLocked = expandOccupiedIds(occIds);
    if (overlapLocked['full-chest'] || overlapLocked['full-front']) overlapLocked['left-chest'] = true;
    overlapLocked['left-leg'] = true;
    overlapLocked['left-thigh'] = true;
    wiOffer.locations = (wiOffer.locations || []).filter(function (loc) {
      return loc && loc.id && !overlapLocked[loc.id];
    });
    (wiOffer.locations || []).forEach(function (loc) {
      const classId = wiOffer.classId || (verifiedWi && verifiedWi.classId);
      const stamped = wisconsinLocationRecord(loc.id, classId);
      const box = locationPrintBox(loc, classId);
      loc.mockupAnchor = {
        view: (stamped && stamped.view) || loc.view || (loc.mockupAnchor && loc.mockupAnchor.view),
        viewImageIndex: stamped && stamped.viewImageIndex != null
          ? stamped.viewImageIndex
          : loc.viewImageIndex,
        box: Object.assign({}, box)
      };
      if (stamped) {
        loc.view = stamped.view;
        loc.viewImageIndex = stamped.viewImageIndex;
        loc.fieldLayout = loc.fieldLayout || stamped.fieldLayout;
      }
    });
    if ((!Array.isArray(wiOffer.ink) || !wiOffer.ink.length) && verifiedWi) {
      wiOffer.ink = verifiedWi.inks.slice();
    }
    if ((!wiOffer.occupancy || !wiOffer.occupancy.length) && verifiedWi) {
      wiOffer.occupancy = verifiedWi.occupied.map(function (id) { return { id: id }; });
    }
    if (verifiedWi && !(wiOffer.garmentColor && (wiOffer.garmentColor.name || wiOffer.garmentColor.family))) {
      wiOffer.garmentColor = {
        family: verifiedWi.color.toLowerCase().replace(/\s+/g, '-'),
        name: verifiedWi.color,
        hex: ''
      };
    }
    if (!wiOffer.schoolColors || !wiOffer.schoolColors.primary) {
      wiOffer.schoolColors = wiStoreFlag
        ? Object.assign({}, WI_TEST_SCHOOL_COLORS)
        : Object.assign({}, schoolColors || {});
    }
    if (!(wiOffer.garmentColor && wiOffer.garmentColor.hex)) {
      const fromPdp = readGarmentFromPdp();
      if (fromPdp.hex || fromPdp.family) {
        wiOffer.garmentColor = Object.assign({}, wiOffer.garmentColor || {}, fromPdp);
      }
    }
  }
  function wisconsinActive() { return !!wiOffer; }
  // House-brand (Ghost Fit / GhostFit / Ghost Fit Apparel / Ghost Fit Sports):
  // customization is FREE. Liquid sets data-house-brand from product.vendor,
  // custom.brand_partner / custom.brand, title, and tags.
  function isGhostFitHouseBrand() {
    // The blob is the authority in BOTH directions: perLocation === 0 IS the
    // house-brand price, and any price above 0 means v4 minted a paid variant
    // ladder — so a numeric price settles it and the liquid attributes below
    // never get a say. They are the fallback ONLY for blobs that predate
    // pricing[]. (Some Nike/Adidas products carry vendor "Ghostfit Apparel",
    // so the attribute alone called a $10 product free and the storefront
    // never swapped to the paid variant.)
    if (config && config.pricing && typeof config.pricing.perLocation === 'number') {
      return config.pricing.perLocation === 0;
    }
    const dlg = document.getElementById('gf-pz-dialog');
    if (dlg && dlg.getAttribute('data-house-brand') === 'true') return true;
    if (zonesContainer && zonesContainer.getAttribute('data-house-brand') === 'true') return true;
    return false;
  }
  const wiStamps = {};
  let wiType = (wiOffer && wiOffer.defaultType) || 'name-number';
  let wiLocationId = wiOffer && Array.isArray(wiOffer.locations) && wiOffer.locations[0]
    ? wiOffer.locations[0].id : '';
  if (wiOffer && wiLocationId && !(wiOffer.locations || []).some(function (l) { return l.id === wiLocationId; })) {
    wiLocationId = wiOffer.locations[0] ? wiOffer.locations[0].id : '';
  }
  if (wiOffer && wiLocationId && wisconsinOccupiedSet()[wiLocationId]) {
    const firstOpen = (wiOffer.locations || []).find(function (l) { return l && l.id && !wisconsinOccupiedSet()[l.id]; });
    wiLocationId = firstOpen ? firstOpen.id : '';
  }

  function wisconsinOccupiedSet() {
    const ids = ((wiOffer && wiOffer.occupancy) || []).map(function (o) { return o.id; })
      .concat((verifiedWi && verifiedWi.occupied) || []);
    const locked = expandOccupiedIds(ids);
    if (locked['full-chest'] || locked['full-front']) locked['left-chest'] = true;
    locked['left-leg'] = true;
    locked['left-thigh'] = true;
    return locked;
  }
  function wisconsinOpenLocationForView(view) {
    const spec = WI_VIEWS.find(v => v.id === view);
    const ids = (spec && spec.locations) || [];
    const occupied = wisconsinOccupiedSet();
    const open = (wiOffer.locations || []).filter(function (l) {
      return l && l.id && !occupied[l.id];
    });
    for (let i = 0; i < ids.length; i++) {
      const id = ids[i];
      if (occupied[id]) continue;
      if (id === 'left-chest' && (occupied['full-chest'] || occupied['full-front'])) continue;
      if (id === 'left-leg' || id === 'left-thigh') continue;
      if (open.some(function (l) { return l.id === id; })) return id;
    }
    return null;
  }
  // Location menu: all four garment locations, in garment order. An open
  // location resolves to its offered record; a location the logo, a brand
  // mark, or an unapproved print box has taken stays LISTED but disabled, so
  // the shopper sees why a sleeve or the front is not on offer instead of a
  // two-entry menu. Joggers have no sleeves.
  const WI_LOCATION_MENU = [
    { id: 'front', label: 'Front', ids: ['left-chest', 'full-chest', 'left-leg'] },
    { id: 'back', label: 'Back', ids: ['back'] },
    { id: 'left-sleeve', label: 'Left Sleeve', ids: ['left-sleeve'] },
    { id: 'right-sleeve', label: 'Right Sleeve', ids: ['right-sleeve'] }
  ];
  const WI_LOCATION_UNAVAILABLE = ' (not available)';
  function wisconsinLocationOptions() {
    const offered = (wiOffer && wiOffer.locations) || [];
    const occupied = wisconsinOccupiedSet();
    const jogger = wisconsinIsJogger();
    const out = [];
    WI_LOCATION_MENU.forEach(function (m) {
      if (jogger && (m.id === 'left-sleeve' || m.id === 'right-sleeve')) return;
      const open = offered.find(function (l) { return l && l.id && m.ids.indexOf(l.id) !== -1 && !occupied[l.id]; });
      if (open) { out.push({ id: open.id, label: open.label || m.label }); return; }
      out.push({ id: 'unavailable:' + m.id, label: m.label + WI_LOCATION_UNAVAILABLE, disabled: true });
    });
    return out;
  }
  function viewForWisconsinLocation(id) {
    const loc = (wiOffer.locations || []).find(l => l.id === id);
    if (loc && loc.view) return loc.view;
    const geo = WI_LOCATION_GEO[id];
    return (geo && geo.view) || 'front';
  }
  // Display hangers come from Shopify product media (Liquid data-img-src /
  // image_url on the view pills). WI attach writes the personalization blob
  // without views.imageUrl — do not synthesize public locked-studio GCS
  // URLs (those 403 after the bucket lock). Leftover views.side 3/4 shots
  // are not location views.
  // Apple-style empty state (owner call 2026-09-09). The plate used to paint a
  // sample "NOBLE 37", which reads as somebody's real name and number; it now
  // shows the PROMPT on the name line only — no sample number, no number line —
  // and the first keystroke switches the plate to typed values alone. The fields
  // are labelled "Name" / "Number" (the blob's legacy "Last Name" reads like a
  // checkout form) and both placeholders read the prompt in sentence case.
  // No prompt on the garment (Grant, 2026-09-10): the plate stays EMPTY until
  // the shopper types; the inputs carry the "Your personalization" placeholder.
  const WI_FIELD_PLACEHOLDER = 'Your personalization';
  const WI_FIELD_LABELS = { name: 'Name', number: 'Number' };
  // Hanger mode only. Zone-card (non-hanger) products keep their blob labels.
  function wisconsinFieldLabel(field) {
    if (!wisconsinActive()) return field.label;
    return WI_FIELD_LABELS[field.id] || field.label;
  }
  function wisconsinFieldPlaceholder(field) {
    return wisconsinActive() ? WI_FIELD_PLACEHOLDER : (field.placeholder || '');
  }
  function isLeftoverSideUrl(url) {
    const s = String(url || '').toLowerCase();
    if (!s) return true;
    if (/(?:^|\/)side\.(?:png|jpe?g|webp)(?:$|[?#])/.test(s)) return true;
    return false;
  }
  function isLockedStudioHangerUrl(url) {
    return /(?:https:\/\/storage\.googleapis\.com\/|gs:\/\/)ghostfit-locked-studio-[^/]+\/hangers\//i.test(String(url || ''));
  }
  function shopifyHangerSrc(url) {
    const s = String(url || '');
    if (!s || isLeftoverSideUrl(s) || isLockedStudioHangerUrl(s)) return '';
    return s;
  }
  function wisconsinIsJogger() {
    const classId = (wiOffer && wiOffer.classId) || (verifiedWi && verifiedWi.classId) || '';
    if (classId === 'jogger') return true;
    return /jogger/.test(String(productHandle || ''));
  }
  function ensureWisconsinViewPills() {
    if (!wisconsinActive() || !previewRoot) return;
    let host = previewRoot.querySelector('.gf-pz-pills');
    if (!host) {
      host = document.createElement('div');
      host.className = 'gf-pz-pills';
      host.setAttribute('role', 'tablist');
      const wrap = previewRoot.querySelector('.gf-pz-preview') || previewRoot;
      wrap.appendChild(host);
    }
    const existing = Array.from(host.querySelectorAll('.pd-thumb'));
    const byView = {};
    existing.forEach(function (t, i) {
      const v = ((t.dataset && t.dataset.view) || '').toLowerCase();
      if (!v || v === 'side') return;
      if (!byView[v]) byView[v] = t;
      if (i === 0 && !byView.front && v === 'front') byView.front = t;
    });
    const fallbackSrc = shopifyHangerSrc(
      (mainImg && mainImg.getAttribute('src'))
      || (byView.front && byView.front.dataset.imgSrc)
      || (existing[0] && existing[0].dataset.view !== 'side' && existing[0].dataset.imgSrc)
      || ''
    );
    const jogger = wisconsinIsJogger();
    // Every PRODUCT view the gallery carries stays a pill — front, back, left
    // sleeve, right sleeve — whether or not a location is open there (Grant,
    // 2026-09-10: the PDP showed four views but the modal only two). A pill
    // whose view has no open location just shows the hanger; the Location
    // menu lists that location as unavailable.
    const specs = (jogger
      ? WI_VIEWS.filter(function (s) { return s.id === 'front' || s.id === 'back'; })
      : WI_VIEWS
    ).filter(function (spec) {
      if (spec.id === 'front') return true;
      if (spec.id === 'back') return true;
      return !!shopifyHangerSrc(byView[spec.id] && byView[spec.id].dataset.imgSrc);
    });
    host.replaceChildren();
    specs.forEach(function (spec) {
      const prior = byView[spec.id];
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pd-thumb';
      btn.dataset.view = spec.id;
      btn.textContent = spec.label;
      const sleeve = spec.id === 'left-side' || spec.id === 'right-side';
      const priorSrc = shopifyHangerSrc(prior && prior.dataset.imgSrc);
      // Liquid data-img-src for every view, including back and sleeves.
      // Empty blob / missing thumb: no public GCS fallback.
      const src = sleeve
        ? priorSrc
        : (priorSrc || (spec.id === 'front' ? fallbackSrc : ''));
      if (src) btn.dataset.imgSrc = src;
      host.appendChild(btn);
    });
    thumbs = Array.from(host.querySelectorAll('.pd-thumb'));
  }
  if (wisconsinActive()) ensureWisconsinViewPills();

  // -------------------------------------------------------------------
  // Per-zone state. Single-zone products auto-enable (matches the prior
  // single-zone UX). Multi-zone products start with every zone disabled —
  // the customer toggles them on individually.
  // -------------------------------------------------------------------
  // The four ink colors every personalized product offers: the school's
  // primary + secondary (resolved from the school-colors blob) plus black and
  // white. Forced here so the chooser shows even when a template ships a single
  // ink, and so a stale/off-palette default token can't strand the preview.
  // Wisconsin: hide any swatch that would disappear into the garment.
  const PERS_INK_CHOICES_ALL = ['school-primary', 'school-secondary', 'black', 'white'];
  const PERS_INK_CHOICES = wisconsinActive()
    ? filterWisconsinInks(PERS_INK_CHOICES_ALL)
    : PERS_INK_CHOICES_ALL;

  function applyWisconsinLocationToZone(zone) {
    if (!wisconsinActive()) return zone;
    const loc = (wiOffer.locations || []).find(l => l.id === wiLocationId) || wiOffer.locations[0];
    if (!loc) return zone;
    const classId = wiOffer.classId || (verifiedWi && verifiedWi.classId);
    const stamped = wisconsinLocationRecord(loc.id, classId);
    const box = locationPrintBox(loc, classId);
    zone.label = loc.label;
    zone.calibration = {
      view: (stamped && stamped.view) || loc.view,
      viewImageIndex: loc.viewImageIndex == null ? null : loc.viewImageIndex,
      mockupAnchor: { box: Object.assign({}, box) },
      fieldLayout: loc.fieldLayout || (stamped && stamped.fieldLayout)
    };
    return zone;
  }
  // Hanger mode limits (Grant, 2026-09-10): a number can be three digits and a
  // last name is not counted at the shopper — the plate and the print both fit
  // text to the box width, so a long surname shrinks rather than truncates.
  // 20 characters is the silent hard stop; no counter is shown.
  const WI_FIELD_LIMITS = { name: 20, number: 3 };
  if (wisconsinActive()) {
    zones.forEach(function (z) {
      ((z.template && z.template.fields) || []).forEach(function (f) {
        if (WI_FIELD_LIMITS[f.id]) f.maxChars = WI_FIELD_LIMITS[f.id];
      });
    });
  }
  if (wisconsinActive() && zones[0]) applyWisconsinLocationToZone(zones[0]);

  const zoneStates = zones.map(zone => ({
    zoneId: zone.id,
    zone: zone,
    enabled: !isMultiZone || autoEnableZones,  // single-zone or modal: pre-enabled
    values: {},
    font: resolvePreviewFont(zone),
    inkColor: pickWisconsinInk(zone),
    placeholderMap: buildPlaceholderMap(zone.template.fields),
    targetImageIndex: viewIndexForZone(zone)
  }));

  let activeImageIndex = 0;

  // The personalization preview shows ONLY the views that matter: the front
  // plus each zone's target view. Model / lifestyle / detail shots are hidden
  // and matched pills are labeled by their view (product call 2026-07-09).
  // Scoped to the modal (previewRoot) — the page gallery is never touched.
  // 2026-09-08 (Grant): every PRODUCT view stays visible — front, back, left
  // sleeve, right sleeve — even when it carries no zone. Only unlabeled media
  // (model / lifestyle / detail shots, no data-view) are hidden.
  if (previewRoot && thumbs.length && !wisconsinActive()) {
    const zoneTargets = new Set(zoneStates.map(zs => zs.targetImageIndex));
    thumbs.forEach((t, i) => {
      const tv = ((t.dataset && t.dataset.view) || '').toLowerCase();
      if (i !== 0 && !zoneTargets.has(i) && !tv) {
        t.hidden = true;
        t.style.display = 'none';
      }
    });
    thumbs.forEach((t, i) => {
      const tv = ((t.dataset && t.dataset.view) || '').toLowerCase();
      const zs = zoneStates.find(z => z.targetImageIndex === i);
      const v = zs ? String((zs.zone.calibration && zs.zone.calibration.view) || '').toLowerCase() : tv;
      if (!v) return;
      t.textContent = prettySideLabel(v);
    });
  }

  // -------------------------------------------------------------------
  // Utility helpers
  // -------------------------------------------------------------------
  function parsePriceCents(str) {
    if (!str) return null;
    const m = str.replace(/[, ]/g, '').match(/(\d+)(?:\.(\d{1,2}))?/);
    if (!m) return null;
    return (parseInt(m[1], 10) || 0) * 100 + (m[2] ? parseInt((m[2] + '00').slice(0, 2), 10) : 0);
  }
  // Re-use the shop's money format from an existing string ("$40.00") with a
  // new cents value, so this file never hardcodes a currency symbol.
  function formatMoneyLike(sample, cents) {
    return String(sample || '$0.00').replace(/[\d.,]+/, (cents / 100).toFixed(2));
  }
  function prettyFontName(f) {
    return f.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  }
  function prettyInkName(c) {
    if (c === 'school-primary') return 'School color';
    if (c === 'school-secondary') return 'Secondary';
    if (c === 'black') return 'Black';
    if (c === 'white') return 'White';
    return c.replace(/\b\w/g, x => x.toUpperCase());
  }
  function prettyViewLabel(view) {
    if (!view) return 'Front';
    return view.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  }
  // left-side / left-sleeve → "Left sleeve"; right-side → "Right sleeve"; else pretty.
  function prettySideLabel(view) {
    const v = String(view || '').toLowerCase();
    if (v.indexOf('side') !== -1 || v.indexOf('sleeve') !== -1) {
      if (v.indexOf('right') !== -1) return 'Right sleeve';
      if (v.indexOf('left') !== -1) return 'Left sleeve';
      return 'Sleeve';
    }
    return prettyViewLabel(v);
  }
  function resolveColor(name) {
    // The last-ditch fallback stays NEUTRAL off the test stores: a store with no
    // school colours must not print Wisconsin cardinal on its plate.
    if (name === 'school-primary') return (wiOffer && wiOffer.schoolColors && wiOffer.schoolColors.primary) || schoolColors.primary || (wiStoreFlag ? WI_TEST_SCHOOL_COLORS.primary : '#000000');
    if (name === 'school-secondary') return (wiOffer && wiOffer.schoolColors && wiOffer.schoolColors.secondary) || schoolColors.secondary || (wiStoreFlag ? WI_TEST_SCHOOL_COLORS.secondary : '#FFFFFF');
    if (name === 'black') return '#000000';
    if (name === 'white') return '#FFFFFF';
    return name;
  }
  function parseHexRgb(hex) {
    const h = String(hex || '').replace('#', '');
    if (!/^[0-9a-fA-F]{6}$/.test(h)) return null;
    return { r: parseInt(h.slice(0, 2), 16), g: parseInt(h.slice(2, 4), 16), b: parseInt(h.slice(4, 6), 16) };
  }
  function hexNearlySame(a, b) {
    const A = parseHexRgb(a);
    const B = parseHexRgb(b);
    if (!A || !B) return false;
    const dr = A.r - B.r, dg = A.g - B.g, db = A.b - B.b;
    return Math.sqrt(dr * dr + dg * dg + db * db) <= 64;
  }
  function normalizeInkHex(hex) {
    return String(hex || '').replace('#', '').toUpperCase();
  }
  function dedupeWisconsinInks(choices) {
    const rank = { white: 3, black: 3, 'school-primary': 2, 'school-secondary': 1 };
    const bestByHex = {};
    (choices || []).forEach(function (id) {
      const hex = normalizeInkHex(resolveColor(id));
      if (!hex) return;
      const prev = bestByHex[hex];
      if (!prev || (rank[id] || 0) > (rank[prev] || 0)) bestByHex[hex] = id;
    });
    const winners = {};
    Object.keys(bestByHex).forEach(function (hex) { winners[bestByHex[hex]] = true; });
    const out = [];
    (choices || []).forEach(function (id) {
      if (!winners[id]) return;
      winners[id] = false;
      out.push(id);
    });
    return out;
  }
  function filterWisconsinInks(choices) {
    let list = (Array.isArray(wiOffer && wiOffer.ink) && wiOffer.ink.length)
      ? wiOffer.ink.slice()
      : (choices || []).slice();
    const garmentHex = wiOffer && wiOffer.garmentColor && wiOffer.garmentColor.hex;
    const family = String((wiOffer && wiOffer.garmentColor && wiOffer.garmentColor.family) || '').toLowerCase();
    const hide = (id) => {
      if (id === 'black' && family.indexOf('black') !== -1 && family.indexOf('anthracite') === -1) return true;
      if (id === 'white' && family.indexOf('white') !== -1) return true;
      if (id === 'school-secondary' && family.indexOf('white') !== -1) return true;
      if (id === 'school-primary' && /red|cardinal/.test(family)) return true;
      return !!(garmentHex && hexNearlySame(resolveColor(id), garmentHex));
    };
    if (!(Array.isArray(wiOffer && wiOffer.ink) && wiOffer.ink.length)) {
      const filtered = list.filter(id => !hide(id));
      list = filtered.length ? filtered : list;
    }
    return dedupeWisconsinInks(list);
  }
  function pickWisconsinInk(zone) {
    const preferred = zone && zone.template && zone.template.defaultInkColor;
    if (PERS_INK_CHOICES.indexOf(preferred) !== -1) return preferred;
    return PERS_INK_CHOICES[0] || 'school-primary';
  }
  function wisconsinVisibleFields() {
    if (!wisconsinActive()) return null;
    const t = (wiOffer.types || []).find(x => x.id === wiType);
    return (t && t.fields) || ['name', 'number'];
  }
  function currentWisconsinLocation() {
    if (!wisconsinActive()) return null;
    return (wiOffer.locations || []).find(l => l.id === wiLocationId) || wiOffer.locations[0] || null;
  }
  function isLightColor(hex) {
    if (!hex || hex[0] !== '#') return false;
    const h = hex.replace('#', '');
    const r = parseInt(h.slice(0, 2), 16);
    const g = parseInt(h.slice(2, 4), 16);
    const b = parseInt(h.slice(4, 6), 16);
    return (0.2126 * r + 0.7152 * g + 0.0722 * b) > 170;
  }
  function viewIndexForZone(zone) {
    const cal = zone.calibration;
    // Resolve by VIEW first: thumbs carry data-view from media alts
    // ("front" / "back" / "left sleeve" / "right sleeve"). Leftover generate
    // "side" 3/4 shots are not location views. The calibrated viewImageIndex
    // was authored against older galleries that still had a 3/4 "side" shot.
    const view = cal && cal.view ? String(cal.view).toLowerCase() : '';
    if (view && thumbs.length) {
      const aliases = view === 'left-side' ? ['left-side', 'left-sleeve']
        : view === 'right-side' ? ['right-side', 'right-sleeve']
        : [view];
      const idx = thumbs.findIndex(t => {
        const tv = ((t.dataset && t.dataset.view) || '').toLowerCase();
        if (!tv) return false;
        if (aliases.indexOf(tv) !== -1) return true;
        if (wisconsinActive()) return false;
        // Loose "side" fallback stays side-specific: a left-side zone never
        // lands on the right-sleeve photo now that both sleeves ship.
        const sideOf = (x) => (x.indexOf('right') !== -1 ? 'right' : (x.indexOf('left') !== -1 ? 'left' : ''));
        return tv.indexOf('side') !== -1 && view.indexOf('side') !== -1 && sideOf(tv) === sideOf(view);
      });
      if (idx !== -1) return idx;
    }
    // Wisconsin: never use stale viewImageIndex (assumes [front,back,LS,RS]).
    if (wisconsinActive()) return -1;
    return (cal && typeof cal.viewImageIndex === 'number') ? cal.viewImageIndex : 0;
  }
  function buildPlaceholderMap(fields) {
    const out = {};
    for (const f of fields) out[f.id] = f.placeholder || f.label || '';
    return out;
  }
  function zoneHasEnteredValues(zs) {
    return Object.values(zs.values).some(v => v && v.trim());
  }
  function locationAddonCents() {
    if (isGhostFitHouseBrand()) return 0;
    // The blob's contract first (pricing.perLocation), the WI offer next, $10 last.
    const per = config && config.pricing && config.pricing.perLocation != null
      ? config.pricing.perLocation
      : ((wiOffer && wiOffer.addon) || 10);
    return Math.round(Number(per) * 100);
  }
  function wisconsinFieldsForType(typeId) {
    const t = ((wiOffer && wiOffer.types) || []).find(x => x.id === typeId);
    return (t && t.fields) || ['name', 'number'];
  }
  function wisconsinStampHasRealValues(stamp) {
    if (!stamp || !stamp.values) return false;
    return wisconsinFieldsForType(stamp.type).some(id => String(stamp.values[id] || '').trim());
  }
  function rememberWisconsinStamp() {
    if (!wisconsinActive() || !wiLocationId || !zoneStates[0]) return;
    wiStamps[wiLocationId] = { type: wiType, values: Object.assign({}, zoneStates[0].values) };
  }
  function restoreWisconsinStamp() {
    if (!wisconsinActive() || !wiLocationId || !zoneStates[0]) return;
    const zs = zoneStates[0];
    const saved = wiStamps[wiLocationId] || { type: (wiOffer && wiOffer.defaultType) || 'name-number', values: {} };
    wiType = saved.type || (wiOffer && wiOffer.defaultType) || 'name-number';
    const typeSel = zonesContainer && zonesContainer.querySelector('select[data-wi-type]');
    if (typeSel) typeSel.value = wiType;
    for (const field of zs.zone.template.fields) {
      const next = (saved.values && saved.values[field.id]) || '';
      zs.values[field.id] = next;
      const input = zonesContainer && zonesContainer.querySelector('input[data-zone-field="' + cssEscape(zs.zoneId + ':' + field.id) + '"]');
      if (input) input.value = next;
      const counter = zonesContainer && zonesContainer.querySelector('[data-counter-for="' + cssEscape(zs.zoneId + ':' + field.id) + '"]');
      if (counter) {
        counter.textContent = next.length + ' / ' + field.maxChars;
        counter.classList.toggle('is-full', field.maxChars > 0 && next.length === field.maxChars);
      }
    }
    applyWisconsinFieldVisibility();
  }
  // Every location the shopper actually filled, in the offer's order.
  // Each entry: { id, type, values }.
  function wisconsinFilledLocations() {
    if (!wisconsinActive()) return [];
    rememberWisconsinStamp();
    const out = [];
    const seen = {};
    ((wiOffer && wiOffer.locations) || []).forEach(function (loc) {
      if (!loc || !loc.id || seen[loc.id]) return;
      const stamp = loc.id === wiLocationId && zoneStates[0]
        ? { type: wiType, values: zoneStates[0].values }
        : wiStamps[loc.id];
      if (wisconsinStampHasRealValues(stamp)) {
        seen[loc.id] = true;
        out.push({ id: loc.id, type: stamp.type, values: Object.assign({}, stamp.values) });
      }
    });
    return out;
  }
  function wisconsinPersonalizationSummary() {
    if (!wisconsinActive()) return '';
    const filled = wisconsinFilledLocations();
    if (!filled.length) return '';
    const parts = filled.map(function (f) {
      const loc = (wiOffer.locations || []).find(function (l) { return l.id === f.id; }) || {};
      const name = String((f.values && f.values.name) || '').trim().toUpperCase();
      const num = String((f.values && f.values.number) || '').trim();
      const text = [name, num].filter(Boolean).join(' ');
      return text + (loc.label ? ' on ' + loc.label : '');
    });
    const ink = zoneStates[0] ? prettyInkName(zoneStates[0].inkColor) : '';
    return parts.join(', ') + (ink ? ' · ' + ink : '');
  }
  function wisconsinFilledLocationCount() {
    if (!wisconsinActive()) {
      return zoneStates.filter(zs => zs.enabled && zoneHasEnteredValues(zs)).length;
    }
    return wisconsinFilledLocations().length;
  }
  function zoneAddonCents(zs) {
    if (isGhostFitHouseBrand()) return 0;
    if (wisconsinActive()) return locationAddonCents() * Math.max(wisconsinFilledLocationCount(), zoneHasEnteredValues(zs) ? 1 : 0);
    return Math.round((zs.zone.template.pricing.addon || 0) * 100);
  }
  function zoneLabel(zs) {
    return zs.zone.label || prettyViewLabel(zs.zone.calibration && zs.zone.calibration.view) + ' personalization';
  }

  // -------------------------------------------------------------------
  // Card rendering
  // -------------------------------------------------------------------
  function buildAllCards() {
    zonesContainer.replaceChildren();
    for (const zs of zoneStates) {
      zonesContainer.appendChild(buildZoneCard(zs));
    }
  }

  function buildZoneCard(zs) {
    const card = document.createElement('div');
    card.className = 'pd-pers-zone';
    card.dataset.zoneId = zs.zoneId;
    card.dataset.viewIndex = zs.targetImageIndex;
    if (zs.enabled) card.classList.add('is-enabled');

    // Header: title + addon + (for multi-zone) toggle
    const header = document.createElement('header');
    header.className = 'pd-pers-zone-header';

    if (isMultiZone && !autoEnableZones) {
      const toggleLabel = document.createElement('label');
      toggleLabel.className = 'pd-pers-zone-toggle';
      const toggle = document.createElement('input');
      toggle.type = 'checkbox';
      toggle.dataset.zoneToggle = zs.zoneId;
      toggle.checked = zs.enabled;
      const title = document.createElement('strong');
      title.textContent = zoneLabel(zs);
      toggleLabel.appendChild(toggle);
      toggleLabel.appendChild(title);
      header.appendChild(toggleLabel);
    } else {
      const title = document.createElement('strong');
      title.className = 'pd-pers-zone-title';
      title.textContent = zoneLabel(zs);
      header.appendChild(title);
    }

    const addon = document.createElement('span');
    addon.className = 'pd-pers-zone-addon';
    addon.dataset.zoneAddonFor = zs.zoneId;
    addon.textContent = '+$' + (zs.zone.template.pricing.addon || 0).toFixed(2).replace(/\.00$/, '');
    header.appendChild(addon);
    card.appendChild(header);

    // Body — hidden for disabled zones (multi-zone). Always visible for single-zone.
    const body = document.createElement('div');
    body.className = 'pd-pers-zone-body';
    if (!zs.enabled) body.hidden = true;

    // View hint inside the card — shown when this zone is enabled but the
    // active image isn't this zone's view.
    const viewHint = document.createElement('p');
    viewHint.className = 'pd-pers-zone-view-hint';
    viewHint.dataset.zoneViewHintFor = zs.zoneId;
    const viewLabel = prettyViewLabel(zs.zone.calibration && zs.zone.calibration.view);
    const hintIcon = document.createElementNS(SVG_NS, 'svg');
    hintIcon.setAttribute('width', '14');
    hintIcon.setAttribute('height', '14');
    hintIcon.setAttribute('viewBox', '0 0 24 24');
    hintIcon.setAttribute('fill', 'none');
    hintIcon.setAttribute('stroke', 'currentColor');
    hintIcon.setAttribute('stroke-width', '2');
    hintIcon.setAttribute('stroke-linecap', 'round');
    hintIcon.setAttribute('stroke-linejoin', 'round');
    hintIcon.setAttribute('aria-hidden', 'true');
    hintIcon.innerHTML = '<polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>';
    viewHint.appendChild(hintIcon);
    const hintText = document.createElement('span');
    hintText.innerHTML = 'Personalization prints on the <strong>' + escapeHtml(viewLabel) + '</strong>';
    viewHint.appendChild(hintText);
    body.appendChild(viewHint);

    // Fields container — inputs, font, ink for THIS zone
    const fields = document.createElement('div');
    fields.className = 'pd-pers-fields';
    fields.dataset.zoneFieldsFor = zs.zoneId;
    buildZoneFields(zs, fields);
    body.appendChild(fields);

    card.appendChild(body);
    return card;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  }

  function appendSelectField(container, label, datasetKey, options, selected) {
    const wrap = document.createElement('label');
    wrap.className = 'pd-pers-field';
    const labelRow = document.createElement('div');
    labelRow.className = 'pd-pers-field-label';
    const labelText = document.createElement('span');
    labelText.textContent = label;
    labelRow.appendChild(labelText);
    wrap.appendChild(labelRow);
    const sel = document.createElement('select');
    sel.dataset[datasetKey] = 'true';
    for (const opt of options) {
      const el = document.createElement('option');
      el.value = opt.id;
      el.textContent = opt.label;
      if (opt.disabled) el.disabled = true;
      if (opt.id === selected) el.selected = true;
      sel.appendChild(el);
    }
    wrap.appendChild(sel);
    container.appendChild(wrap);
  }

  function applyWisconsinFieldVisibility() {
    if (!wisconsinActive()) return;
    const visible = new Set(wisconsinVisibleFields());
    for (const zs of zoneStates) {
      for (const field of zs.zone.template.fields) {
        const input = zonesContainer.querySelector('input[data-zone-field="' + cssEscape(zs.zoneId + ':' + field.id) + '"]');
        const wrap = input && input.closest('.pd-pers-field');
        const show = visible.has(field.id);
        // Reserve the name + number slots always. Hide unused fields without
        // collapsing so Location and ink stay put when Type / view changes.
        if (wrap) {
          wrap.hidden = !show;
          wrap.classList.toggle('is-reserved-hidden', !show);
        }
        if (input) {
          input.tabIndex = show ? 0 : -1;
          if (show) input.removeAttribute('aria-hidden');
          else input.setAttribute('aria-hidden', 'true');
        }
        if (!show) {
          zs.values[field.id] = '';
          if (input) input.value = '';
          const counter = zonesContainer.querySelector('[data-counter-for="' + cssEscape(zs.zoneId + ':' + field.id) + '"]');
          if (counter) {
            counter.textContent = '0 / ' + field.maxChars;
            counter.classList.remove('is-full');
          }
        }
      }
    }
  }

  function syncWisconsinLocationSelect() {
    const sel = zonesContainer && zonesContainer.querySelector('select[data-wi-location]');
    if (sel && wiLocationId) sel.value = wiLocationId;
  }
  function applyWisconsinLocationState() {
    if (!wisconsinActive()) return;
    const loc = currentWisconsinLocation();
    if (!loc) return;
    const zs = zoneStates[0];
    if (!zs) return;
    applyWisconsinLocationToZone(zs.zone);
    zs.targetImageIndex = viewIndexForZone(zs.zone);
    const card = zonesContainer.querySelector('.pd-pers-zone');
    if (card) card.dataset.viewIndex = zs.targetImageIndex;
    syncWisconsinLocationSelect();
    if (activeImageIndex !== zs.targetImageIndex) setActiveImage(zs.targetImageIndex);
    else applyZoneVisibility(zs);
    updateZoneViewHints();
  }

  function buildZoneFields(zs, container) {
    const t = zs.zone.template;
    if (wisconsinActive()) {
      appendSelectField(container, 'Type', 'wiType', wiOffer.types || [], wiType);
      appendSelectField(container, 'Location', 'wiLocation', wisconsinLocationOptions(), wiLocationId);
    }
    const visibleIds = wisconsinVisibleFields();
    // Text/number inputs
    for (const field of t.fields) {
      const wrap = document.createElement('label');
      wrap.className = 'pd-pers-field';
      const labelRow = document.createElement('div');
      labelRow.className = 'pd-pers-field-label';
      const labelText = document.createElement('span');
      labelText.textContent = wisconsinFieldLabel(field);
      labelRow.appendChild(labelText);
      // No visible character count in hanger mode: the limit is silent and the
      // plate fits whatever is typed (every counter reader null-checks).
      if (!wisconsinActive()) {
        const counter = document.createElement('span');
        counter.className = 'pd-pers-counter';
        counter.dataset.counterFor = zs.zoneId + ':' + field.id;
        counter.textContent = '0 / ' + field.maxChars;
        labelRow.appendChild(counter);
      }
      wrap.appendChild(labelRow);

      const input = document.createElement('input');
      input.type = field.type === 'numeric' ? 'tel' : 'text';
      input.inputMode = field.type === 'numeric' ? 'numeric' : 'text';
      input.maxLength = field.maxChars;
      input.placeholder = wisconsinFieldPlaceholder(field);
      input.dataset.zoneField = zs.zoneId + ':' + field.id;
      if (field.uppercase) input.dataset.uppercase = 'true';
      input.autocomplete = 'off';
      input.spellcheck = false;
      wrap.appendChild(input);
      if (visibleIds && visibleIds.indexOf(field.id) === -1) {
        wrap.hidden = true;
        wrap.classList.add('is-reserved-hidden');
        input.tabIndex = -1;
        input.setAttribute('aria-hidden', 'true');
      }
      container.appendChild(wrap);
    }

    // Font (only if there's a choice)
    if (t.availableFonts.length > 1) {
      const wrap = document.createElement('label');
      wrap.className = 'pd-pers-field';
      const labelRow = document.createElement('div');
      labelRow.className = 'pd-pers-field-label';
      const labelText = document.createElement('span');
      labelText.textContent = 'Font';
      labelRow.appendChild(labelText);
      wrap.appendChild(labelRow);
      const sel = document.createElement('select');
      sel.dataset.zoneFont = zs.zoneId;
      for (const f of t.availableFonts) {
        const opt = document.createElement('option');
        opt.value = f;
        opt.textContent = prettyFontName(f);
        sel.appendChild(opt);
      }
      wrap.appendChild(sel);
      container.appendChild(wrap);
    }

    // Ink swatches — always offer the four standard text colors (school
    // primary/secondary + black/white), regardless of the template's own list.
    if (PERS_INK_CHOICES.length > 1) {
      const wrap = document.createElement('div');
      wrap.className = 'pd-pers-field pd-pers-field--full';
      const labelRow = document.createElement('div');
      labelRow.className = 'pd-pers-field-label';
      const labelText = document.createElement('span');
      labelText.textContent = 'Color';
      labelRow.appendChild(labelText);
      const currentName = document.createElement('span');
      currentName.className = 'pd-pers-counter';
      currentName.dataset.inkCurrentFor = zs.zoneId;
      currentName.textContent = prettyInkName(zs.inkColor);
      labelRow.appendChild(currentName);
      wrap.appendChild(labelRow);

      const row = document.createElement('div');
      row.className = 'pd-pers-swatches';
      row.setAttribute('role', 'radiogroup');
      row.setAttribute('aria-label', 'Color');
      row.dataset.zoneSwatchesFor = zs.zoneId;
      for (const c of PERS_INK_CHOICES) {
        const hex = resolveColor(c);
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pd-pers-swatch';
        btn.style.setProperty('--swatch-fill', hex);
        btn.style.setProperty('--swatch-tick-color', isLightColor(hex) ? '#0a0a0a' : '#ffffff');
        btn.dataset.inkColor = c;
        btn.setAttribute('aria-label', prettyInkName(c));
        btn.setAttribute('aria-pressed', c === zs.inkColor ? 'true' : 'false');
        const tickWrap = document.createElement('span');
        tickWrap.className = 'pd-pers-swatch-tick';
        const tickSvg = document.createElementNS(SVG_NS, 'svg');
        tickSvg.setAttribute('width', '14');
        tickSvg.setAttribute('height', '14');
        tickSvg.setAttribute('viewBox', '0 0 24 24');
        tickSvg.setAttribute('fill', 'none');
        tickSvg.setAttribute('stroke', 'currentColor');
        tickSvg.setAttribute('stroke-width', '3');
        tickSvg.setAttribute('stroke-linecap', 'round');
        tickSvg.setAttribute('stroke-linejoin', 'round');
        const tickPath = document.createElementNS(SVG_NS, 'polyline');
        tickPath.setAttribute('points', '20 6 9 17 4 12');
        tickSvg.appendChild(tickPath);
        tickWrap.appendChild(tickSvg);
        btn.appendChild(tickWrap);
        row.appendChild(btn);
      }
      wrap.appendChild(row);
      container.appendChild(wrap);
    }
  }

  // -------------------------------------------------------------------
  // SVG rendering — every zone renders into a dedicated <g>. Hidden when
  // the zone is disabled OR when the active image doesn't match the zone's
  // view. Mid-text changes only re-render the affected zone's <g>.
  // -------------------------------------------------------------------
  function renderZoneSVG(zs, opts) {
    const animateField = opts && opts.animateField;
    const Svg = window.GfSvg;

    // Find or create this zone's group inside the SVG
    let g = svg.querySelector('g[data-zone-id="' + cssEscape(zs.zoneId) + '"]');
    if (!g) {
      g = document.createElementNS(SVG_NS, 'g');
      g.setAttribute('data-zone-id', zs.zoneId);
      svg.appendChild(g);
    } else {
      while (g.firstChild) g.removeChild(g.firstChild);
    }

    const cal = zs.zone.calibration;
    const { box } = cal.mockupAnchor;
    const fontFamilyClass = 'gf-font-' + zs.font;
    const fill = resolveColor(zs.inkColor);

    let defs = null;
    function ensureDefs() {
      if (defs) return defs;
      defs = document.createElementNS(SVG_NS, 'defs');
      g.appendChild(defs);
      return defs;
    }

    const visibleIds = wisconsinVisibleFields();
    const activeFields = zs.zone.template.fields.filter(field => {
      if (visibleIds && visibleIds.indexOf(field.id) === -1) return false;
      const layout = cal.fieldLayout && cal.fieldLayout[field.id];
      return !!layout;
    });
    // Wisconsin: name-only / number-only fill the selected location box.
    // Name+number partitions that same box (name | ~10% gap | number).
    // Do not honor blob fieldLayout y/fontSizePct — those leftover-band
    // tokens shrink the stack to ~70% of the plate.
    const stackNameNumber = wisconsinActive() && wiType === 'name-number'
      && activeFields.length > 1;
    const fillApprovedBox = { x: 0.5, y: 0.5, fontSizePct: 1, align: 'center' };

    if (wisconsinActive() && box) {
      const boxAbs = wisconsinBoxAbs(box);
      const clipId = 'gf-wi-plate-' + String(zs.zoneId).replace(/[^a-zA-Z0-9_-]/g, '-');
      const clipPath = document.createElementNS(SVG_NS, 'clipPath');
      clipPath.setAttribute('id', clipId);
      const rect = document.createElementNS(SVG_NS, 'rect');
      rect.setAttribute('x', String(boxAbs.x));
      rect.setAttribute('y', String(boxAbs.y));
      rect.setAttribute('width', String(boxAbs.w));
      rect.setAttribute('height', String(boxAbs.h));
      clipPath.appendChild(rect);
      ensureDefs().appendChild(clipPath);
      g.setAttribute('clip-path', 'url(#' + clipId + ')');
    } else {
      g.removeAttribute('clip-path');
    }

    for (const field of activeFields) {
      const layout = cal.fieldLayout[field.id];
      const rawValue = zs.values[field.id] || '';
      const isPlaceholder = rawValue.length === 0;
      let text = rawValue;
      if (isPlaceholder) {
        if (!wisconsinActive()) text = zs.placeholderMap[field.id];
        else continue; // hanger mode: typed values only, nothing painted until they type
      }
      if (!text) continue;
      const display = field.uppercase ? text.toUpperCase() : text;
      const animate = animateField === field.id;
      const built = (wisconsinActive() && stackNameNumber)
        ? buildStackedFieldElement(zs.zoneId, field, layout, box, display, fill, fontFamilyClass, isPlaceholder, animate)
        : buildFieldElement(
          zs.zoneId,
          field,
          (wisconsinActive() ? fillApprovedBox : layout),
          box,
          display,
          fill,
          fontFamilyClass,
          isPlaceholder,
          animate
        );
      if (!built) continue;
      if (built.defsPath) ensureDefs().appendChild(built.defsPath);
      g.appendChild(built.el);
    }

    applyZoneVisibility(zs);
  }

  function cssEscape(s) {
    return s.replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }

  // Fill-the-zone sizing (product call 2026-07-09): personalization text
  // renders STRAIGHT and fills the zone box calibrated in product-config-admin
  // — the template's legacy shape ('arch-top' etc.) and fontSizePct tokens are
  // intentionally ignored. Start from the box height, cap by the measured
  // glyph run vs the box width (hidden in-document <text> node, so
  // class-resolved webfont metrics apply; advance is linear in font-size, so
  // one measurement is exact), then center the glyphs vertically in the box.
  const FIT_PAD_W = 0.94; // 6% side padding inside the calibrated box
  const FILL_H = 0.95;    // height headroom inside the calibrated box
  let fitMeasureText = null;
  let fitMeasureCtx = null;
  function ensureFitMeasureNodes() {
    if (fitMeasureText) return;
    // Hidden in-document <text> node: resolves the font class to a concrete
    // font-family the same way the render does.
    const holder = document.createElementNS(SVG_NS, 'svg');
    holder.setAttribute('aria-hidden', 'true');
    holder.style.cssText = 'position:absolute;left:-9999px;top:0;width:10px;height:10px;overflow:hidden;visibility:hidden;pointer-events:none;';
    fitMeasureText = document.createElementNS(SVG_NS, 'text');
    holder.appendChild(fitMeasureText);
    document.body.appendChild(holder);
    fitMeasureCtx = document.createElement('canvas').getContext('2d');
  }
  function fitFillFont(display, geom, fontFamilyClass) {
    const availW = geom.boxAbs.w * FIT_PAD_W;
    const availH = geom.boxAbs.h * FILL_H;
    const centerY = geom.boxAbs.y + geom.boxAbs.h / 2;
    if (!display || !display.length) {
      return { fontSize: availH, baselineY: centerY + availH * 0.35 };
    }
    ensureFitMeasureNodes();
    // Probe at an arbitrary size; every metric scales linearly with font-size.
    const probe = 100;
    let width = 0, asc = probe * 0.72, desc = 0; // athletic-block estimates
    try {
      fitMeasureText.setAttribute('class', fontFamilyClass);
      const family = getComputedStyle(fitMeasureText).fontFamily || 'sans-serif';
      fitMeasureCtx.font = probe + 'px ' + family;
      const m = fitMeasureCtx.measureText(display);
      width = m.width || 0;
      // Ink extents (not the em box) so uppercase runs truly fill the zone.
      if (typeof m.actualBoundingBoxAscent === 'number') asc = m.actualBoundingBoxAscent;
      if (typeof m.actualBoundingBoxDescent === 'number') desc = m.actualBoundingBoxDescent;
    } catch (e) { /* keep estimates */ }
    if (width <= 0) width = display.length * probe * 0.62; // avg-advance fallback
    const inkH = Math.max(1, asc + desc);
    const scale = Math.min(availW / width, availH / inkH);
    const fontSize = probe * scale;
    // Center the ink run vertically in the calibrated box.
    const baselineY = centerY + (asc - inkH / 2) * scale;
    return { fontSize: fontSize, baselineY: baselineY };
  }

  const HANGER_VB = { w: 1000, h: 1200 };
  function wisconsinBoxAbs(box) {
    return {
      x: box.x * HANGER_VB.w,
      y: box.y * HANGER_VB.h,
      w: box.w * HANGER_VB.w,
      h: box.h * HANGER_VB.h
    };
  }
  function resolveWisconsinGeometry(box, layout) {
    const boxAbs = wisconsinBoxAbs(box);
    const lx = layout && layout.x != null ? layout.x : 0.5;
    const ly = layout && layout.y != null ? layout.y : 0.5;
    return {
      cx: boxAbs.x + lx * boxAbs.w,
      cy: boxAbs.y + ly * boxAbs.h,
      fontSize: boxAbs.h * ((layout && layout.fontSizePct) || 1),
      boxAbs: boxAbs
    };
  }
  function syncWisconsinSvgViewBox() {
    if (!svg || !wisconsinActive()) return;
    svg.setAttribute('viewBox', '0 0 1000 1200');
    svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
  }
  if (wisconsinActive()) syncWisconsinSvgViewBox();

  function stackedSliceBox(box, fieldId) {
    const isName = fieldId !== 'number';
    const yFrac = isName ? 0 : (STACKED_SLICE_H + STACKED_PLATE_GAP);
    return {
      x: box.x,
      y: box.y + yFrac * box.h,
      w: box.w,
      h: box.h * STACKED_SLICE_H
    };
  }

  function buildStackedFieldElement(zoneId, field, layout, box, display, fill, fontFamilyClass, isPlaceholder, animate) {
    const Svg = window.GfSvg;
    // Partition the approved box. layout.y / layout.fontSizePct are stale
    // leftover-band tokens and must not drive slice size or position.
    const subBox = stackedSliceBox(box, field && field.id);
    const align = (layout && layout.align) || 'center';
    const geom = wisconsinActive()
      ? resolveWisconsinGeometry(subBox, { x: 0.5, y: 0.5, fontSizePct: 1, align: align })
      : Svg.resolveFieldGeometry(subBox, { x: 0.5, y: 0.5, fontSizePct: 1, align: align }, 1000);
    const fitted = fitFillFont(display, geom, fontFamilyClass);
    const textEl = document.createElementNS(SVG_NS, 'text');
    textEl.setAttribute('font-size', fitted.fontSize);
    textEl.setAttribute('text-anchor', align === 'center' ? 'middle' : (align === 'right' ? 'end' : 'start'));
    textEl.setAttribute('fill', fill);
    textEl.setAttribute('class', fontFamilyClass);
    if (isPlaceholder && !wisconsinActive()) {
      textEl.setAttribute('opacity', '0.42');
      textEl.setAttribute('font-style', 'italic');
    }
    if (animate && !isPlaceholder) {
      textEl.classList.add('is-fresh');
      setTimeout(() => textEl.classList.remove('is-fresh'), 350);
    }
    textEl.setAttribute('x', geom.cx);
    textEl.setAttribute('y', fitted.baselineY);
    textEl.textContent = display;
    return { el: textEl, defsPath: null };
  }

  function buildFieldElement(zoneId, field, layout, box, display, fill, fontFamilyClass, isPlaceholder, animate) {
    const Svg = window.GfSvg;
    const geom = wisconsinActive()
      ? resolveWisconsinGeometry(box, layout)
      : Svg.resolveFieldGeometry(box, layout, 1000);

    // Straight fill only — no arcs/slants (product call 2026-07-09). The
    // curved-shape path builders remain in GfSvg for the admin tooling.
    const fitted = fitFillFont(display, geom, fontFamilyClass);

    const textEl = document.createElementNS(SVG_NS, 'text');
    textEl.setAttribute('font-size', fitted.fontSize);
    textEl.setAttribute('text-anchor', layout.align === 'center' ? 'middle' : (layout.align === 'right' ? 'end' : 'start'));
    textEl.setAttribute('fill', fill);
    textEl.setAttribute('class', fontFamilyClass);
    // No stroke/outline on personalization text (product call 2026-07-09) —
    // the ink color chooser (white/black/primary/secondary) is the contrast tool.
    if (isPlaceholder && !wisconsinActive()) {
      textEl.setAttribute('opacity', '0.42');
      textEl.setAttribute('font-style', 'italic');
    }
    if (animate && !isPlaceholder) {
      textEl.classList.add('is-fresh');
      setTimeout(() => textEl.classList.remove('is-fresh'), 350);
    }

    textEl.setAttribute('x', geom.cx);
    textEl.setAttribute('y', fitted.baselineY);
    textEl.textContent = display;
    return { el: textEl, defsPath: null };
  }

  function renderAllZonesSVG() {
    for (const zs of zoneStates) renderZoneSVG(zs);
    updateSvgEmptyState();
  }

  function applyZoneVisibility(zs) {
    const g = svg.querySelector('g[data-zone-id="' + cssEscape(zs.zoneId) + '"]');
    if (!g) return;
    const visible = zs.enabled && (activeImageIndex === zs.targetImageIndex);
    g.style.display = visible ? '' : 'none';
  }

  function applyAllZoneVisibility() {
    for (const zs of zoneStates) applyZoneVisibility(zs);
    updateSvgEmptyState();
    updateZoneViewHints();
  }

  function updateSvgEmptyState() {
    if (wisconsinActive()) {
      // The YOUR PERSONALIZATION prompt paints at full ink — never fade the plate.
      svg.dataset.empty = 'false';
      return;
    }
    const anyVisibleWithValue = zoneStates.some(zs =>
      zs.enabled && activeImageIndex === zs.targetImageIndex && zoneHasEnteredValues(zs)
    );
    svg.dataset.empty = anyVisibleWithValue ? 'false' : 'true';
  }

  function wisconsinHintCopy() {
    const loc = currentWisconsinLocation();
    const label = (loc && loc.label)
      || prettyViewLabel(loc && loc.view)
      || prettyViewLabel(viewForWisconsinLocation(wiLocationId));
    return 'Personalization prints on the <strong>' + escapeHtml(label) + '</strong>';
  }
  function updateZoneViewHints() {
    for (const zs of zoneStates) {
      const hint = zonesContainer.querySelector('[data-zone-view-hint-for="' + cssEscape(zs.zoneId) + '"]');
      if (!hint) continue;
      if (wisconsinActive()) {
        const span = hint.querySelector('span');
        if (span) span.innerHTML = wisconsinHintCopy();
      }
      // Show hint when zone is enabled but active image isn't matching.
      hint.classList.toggle('is-visible', zs.enabled && activeImageIndex !== zs.targetImageIndex);
    }
    // Hide the global liquid-rendered view hint — Phase 2 uses per-zone hints.
    if (globalViewHint) globalViewHint.classList.remove('is-visible');
  }

  // -------------------------------------------------------------------
  // Pricing — total addon = sum of enabled zones, written into header badge
  // and the Add to Bag CTA. Single-zone behavior preserved by treating
  // zone.enabled = true as the default.
  // -------------------------------------------------------------------
  function updatePricing() {
    let totalAddonCents = 0;
    let anyEnabledWithValue = false;
    for (const zs of zoneStates) {
      if (!zs.enabled) continue;
      if (zoneHasEnteredValues(zs)) anyEnabledWithValue = true;
      // We count addon regardless of values entered (consistent with
      // toggle semantics: enabling a zone commits to its addon).
      totalAddonCents += zoneAddonCents(zs);
    }

    if (priceBadge) {
      priceBadge.textContent = '+$' + (totalAddonCents / 100).toFixed(2).replace(/\.00$/, '');
      priceBadge.classList.toggle('is-active', totalAddonCents > 0);
    }
    if (resetBtn) resetBtn.classList.toggle('is-visible', anyEnabledWithValue || totalAddonCents > 0);

    // Wisconsin / modal Add-to-Bag: garment + customization delta.
    // Ghost Fit house: $0 (do not add $10). Other brands: $10 per location
    // that has a real typed name/number. The empty plate's YOUR PERSONALIZATION
    // prompt is never written into values, so it does not count.
    const modalTotal = document.getElementById('pd-pz-total');
    if (modalTotal && (wisconsinActive() || isGhostFitHouseBrand())) {
      // gf-storefront.js writes the selected size's BASE price in cents on the
      // zones container (resolve()); fall back to the first-paint text.
      const baseCentsAttr = zonesContainer && zonesContainer.dataset.basePriceCents;
      if (baseCentsAttr && /^\d+$/.test(baseCentsAttr)) {
        modalTotal.dataset.basePrice = formatMoneyLike(modalTotal.dataset.basePrice || modalTotal.textContent, parseInt(baseCentsAttr, 10));
      } else if (!modalTotal.dataset.basePrice) {
        modalTotal.dataset.basePrice = modalTotal.textContent;
      }
      const filled = wisconsinFilledLocationCount();
      const addon = isGhostFitHouseBrand() ? 0 : locationAddonCents() * filled;
      const base = parsePriceCents(modalTotal.dataset.basePrice);
      if (base != null && addon > 0) {
        modalTotal.textContent = modalTotal.dataset.basePrice.replace(/[\d.,]+/, ((base + addon) / 100).toFixed(2));
      } else {
        modalTotal.textContent = modalTotal.dataset.basePrice;
      }
    }

    // Hand-off to gf-storefront.js: the filled-location count decides which
    // "(Personalized ×k)" variant the cart gets. Announce changes that do not
    // come from an <input> event (location switch, type switch).
    if (zonesContainer) {
      const filledNow = String(wisconsinFilledLocationCount());
      if (zonesContainer.dataset.filledLocations !== filledNow) {
        zonesContainer.dataset.filledLocations = filledNow;
        zonesContainer.dispatchEvent(new CustomEvent('gf:pers-change', { bubbles: true }));
      }
      // Human summary for the buy box's choice card ("NOBLE 37 · Back · School
      // color"). Published on every pricing pass; announced only when it changes.
      const summaryNow = wisconsinPersonalizationSummary();
      if (zonesContainer.dataset.persSummary !== summaryNow) {
        zonesContainer.dataset.persSummary = summaryNow;
        zonesContainer.dispatchEvent(new CustomEvent('gf:pers-summary', { bubbles: true }));
      }
    }

    // Opt-out: when the CTA price span carries data-gf-pers-noautoprice, the
    // host page owns the Add-to-Bag price (e.g. the v4 PDP, where personalization
    // is OPTIONAL and sold as one "(Personalized)" variant at base+combinedAddon —
    // gf-storefront.js swaps the variant + price when a field is filled). The
    // engine's per-zone incremental sum would disagree with that single-variant
    // price, so leave the CTA alone there. The header badge below still updates.
    if (ctaPrice && !ctaPrice.dataset.gfPersNoautoprice && basePriceCents != null) {
      const total = basePriceCents + totalAddonCents;
      if (!ctaPrice.dataset.basePrice) ctaPrice.dataset.basePrice = ctaPrice.textContent;
      ctaPrice.textContent = ctaPrice.dataset.basePrice.replace(/[\d.,]+/, (total / 100).toFixed(2));
    }
  }

  // -------------------------------------------------------------------
  // Image gallery wiring — track which view is currently shown and let
  // zones know whether their SVG <g> should be visible.
  // -------------------------------------------------------------------
  function setMainImage(src) {
    if (!mainImg || !src) return;
    // The main <img> ships with srcset (multiple resolutions of the
    // featured image). Browser uses srcset over src — clear it first.
    mainImg.removeAttribute('srcset');
    mainImg.src = src;
  }

  function setActiveImage(index, opts) {
    if (index < 0 || index >= thumbs.length) {
      // No thumb for this index — just track state for SVG visibility.
      activeImageIndex = index;
      applyAllZoneVisibility();
      return;
    }
    setMainImage(thumbs[index].dataset.imgSrc);
    thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
    activeImageIndex = index;
    applyAllZoneVisibility();
  }

  thumbs.forEach((thumb, i) => {
    thumb.addEventListener('click', () => {
      setActiveImage(i);
      if (!wisconsinActive()) return;
      const view = ((thumb.dataset && thumb.dataset.view) || '').toLowerCase();
      const next = wisconsinOpenLocationForView(view);
      const occupied = wisconsinOccupiedSet();
      if (next && next !== wiLocationId && !occupied[next]) {
        rememberWisconsinStamp();
        wiLocationId = next;
        restoreWisconsinStamp();
        applyWisconsinLocationState();
        renderAllZonesSVG();
        updatePricing();
      }
    });
  });

  // -------------------------------------------------------------------
  // Event handlers — input changes, swatch clicks, zone toggles, focus
  // -------------------------------------------------------------------
  function bindHandlers() {
    // Input changes (text + font select live here too)
    zonesContainer.addEventListener('input', e => {
      const target = e.target;
      // Field input
      const fieldKey = target.dataset.zoneField;
      if (fieldKey) {
        const [zoneId, fieldId] = fieldKey.split(':');
        const zs = zoneStates.find(z => z.zoneId === zoneId);
        if (!zs) return;
        // Auto-enable when typing into a zone's input (multi-zone case)
        if (!zs.enabled) {
          setZoneEnabled(zs, true);
        }
        const before = zs.values[fieldId] || '';
        const after = target.value;
        zs.values[fieldId] = after;
        const counter = zonesContainer.querySelector('[data-counter-for="' + cssEscape(zoneId + ':' + fieldId) + '"]');
        if (counter) {
          const f = zs.zone.template.fields.find(x => x.id === fieldId);
          const max = f ? f.maxChars : 0;
          counter.textContent = after.length + ' / ' + max;
          counter.classList.toggle('is-full', max > 0 && after.length === max);
        }
        const animate = before.length === 0 && after.length > 0 ? fieldId : null;
        renderZoneSVG(zs, { animateField: animate });
        updateSvgEmptyState();
        updatePricing();
        return;
      }
      if (target.dataset.wiType) {
        // Visibility first: it blanks the fields the new type hides, so the
        // stamp records the values that will actually be sold.
        wiType = target.value;
        applyWisconsinFieldVisibility();
        rememberWisconsinStamp();
        renderAllZonesSVG();
        updatePricing();
        return;
      }
      if (target.dataset.wiLocation) {
        rememberWisconsinStamp();
        wiLocationId = target.value;
        restoreWisconsinStamp();
        applyWisconsinLocationState();
        renderAllZonesSVG();
        updatePricing();
        return;
      }
      // Font select
      const fontZoneId = target.dataset.zoneFont;
      if (fontZoneId) {
        const zs = zoneStates.find(z => z.zoneId === fontZoneId);
        if (!zs) return;
        zs.font = target.value;
        renderZoneSVG(zs);
        return;
      }
    });

    // Click delegation — swatches + toggles
    zonesContainer.addEventListener('click', e => {
      // Ink swatch
      const swatchBtn = e.target.closest('.pd-pers-swatch');
      if (swatchBtn && swatchBtn.disabled) return;
      if (swatchBtn) {
        const row = swatchBtn.closest('[data-zone-swatches-for]');
        if (!row) return;
        const zoneId = row.dataset.zoneSwatchesFor;
        const zs = zoneStates.find(z => z.zoneId === zoneId);
        if (!zs) return;
        const c = swatchBtn.dataset.inkColor;
        if (!c) return;
        zs.inkColor = c;
        row.querySelectorAll('.pd-pers-swatch').forEach(s => s.setAttribute('aria-pressed', s.dataset.inkColor === c ? 'true' : 'false'));
        const currentName = zonesContainer.querySelector('[data-ink-current-for="' + cssEscape(zoneId) + '"]');
        if (currentName) currentName.textContent = prettyInkName(c);
        renderZoneSVG(zs);
        return;
      }
    });

    // Zone toggle (checkbox) — change event
    zonesContainer.addEventListener('change', e => {
      if (e.target.dataset.wiType) {
        // Visibility first: it blanks the fields the new type hides, so the
        // stamp records the values that will actually be sold.
        wiType = e.target.value;
        applyWisconsinFieldVisibility();
        rememberWisconsinStamp();
        renderAllZonesSVG();
        updatePricing();
        return;
      }
      if (e.target.dataset.wiLocation) {
        rememberWisconsinStamp();
        wiLocationId = e.target.value;
        restoreWisconsinStamp();
        applyWisconsinLocationState();
        renderAllZonesSVG();
        updatePricing();
        return;
      }
      const toggleZoneId = e.target.dataset.zoneToggle;
      if (!toggleZoneId) return;
      const zs = zoneStates.find(z => z.zoneId === toggleZoneId);
      if (!zs) return;
      setZoneEnabled(zs, e.target.checked);
    });

    // Focus auto-switch — when customer focuses anything inside a zone's
    // body, snap the gallery to that zone's view.
    // gf-storefront.js announces a new selected-size base price here; the modal
    // total is base + add-on, so it has to be recomputed. updatePricing()'s own
    // gf:pers-change dispatch is change-guarded, so this cannot loop.
    zonesContainer.addEventListener('gf:base-price', updatePricing);

    zonesContainer.addEventListener('focusin', e => {
      const card = e.target.closest('.pd-pers-zone');
      if (!card) return;
      const zoneId = card.dataset.zoneId;
      const zs = zoneStates.find(z => z.zoneId === zoneId);
      if (!zs) return;
      if (activeImageIndex !== zs.targetImageIndex) {
        setActiveImage(zs.targetImageIndex);
      }
    });

    // Reset (global — clears all zones). Exposed as a function AND a document
    // event: the popup has no Reset control of its own, and the buy box's
    // "No personalization" card clears through gf:pers-reset (2026-09-10).
    function resetAllPersonalization() {
        // Reset is global: drop EVERY location's stamp, not just the one on
        // screen. Clearing the visible fields alone left the other locations
        // filled, so the cart kept swapping to "(Personalized xk)".
        if (wisconsinActive()) Object.keys(wiStamps).forEach(function (k) { delete wiStamps[k]; });
        for (const zs of zoneStates) {
          zs.values = {};
          if (isMultiZone) {
            zs.enabled = false;
            const toggle = zonesContainer.querySelector('input[data-zone-toggle="' + cssEscape(zs.zoneId) + '"]');
            if (toggle) toggle.checked = false;
            const card = zonesContainer.querySelector('.pd-pers-zone[data-zone-id="' + cssEscape(zs.zoneId) + '"]');
            if (card) card.classList.remove('is-enabled');
            const body = card && card.querySelector('.pd-pers-zone-body');
            if (body) body.hidden = true;
          }
          // Clear inputs + counters
          for (const f of zs.zone.template.fields) {
            const input = zonesContainer.querySelector('input[data-zone-field="' + cssEscape(zs.zoneId + ':' + f.id) + '"]');
            if (input) input.value = '';
            const counter = zonesContainer.querySelector('[data-counter-for="' + cssEscape(zs.zoneId + ':' + f.id) + '"]');
            if (counter) {
              counter.textContent = '0 / ' + f.maxChars;
              counter.classList.remove('is-full');
            }
          }
          renderZoneSVG(zs);
        }
        updatePricing();
        updateSvgEmptyState();
    }
    if (resetBtn) resetBtn.addEventListener('click', resetAllPersonalization);
    document.addEventListener('gf:pers-reset', resetAllPersonalization);

    // Cart submit
    const form = document.querySelector('form[action*="/cart/add"]');
    if (form) form.addEventListener('submit', writeCartProperties);
  }

  function setZoneEnabled(zs, enabled) {
    zs.enabled = enabled;
    if (!enabled) {
      for (const field of zs.zone.template.fields) {
        zs.values[field.id] = '';
        const input = zonesContainer.querySelector('input[data-zone-field="' + cssEscape(zs.zoneId + ':' + field.id) + '"]');
        if (input) input.value = '';
      }
    }
    const card = zonesContainer.querySelector('.pd-pers-zone[data-zone-id="' + cssEscape(zs.zoneId) + '"]');
    if (card) card.classList.toggle('is-enabled', enabled);
    const body = card && card.querySelector('.pd-pers-zone-body');
    if (body) body.hidden = !enabled;
    const toggle = zonesContainer.querySelector('input[data-zone-toggle="' + cssEscape(zs.zoneId) + '"]');
    if (toggle && toggle.checked !== enabled) toggle.checked = enabled;
    applyZoneVisibility(zs);
    updatePricing();
    // When enabling, snap to this zone's view so the customer sees their preview.
    if (enabled && activeImageIndex !== zs.targetImageIndex) {
      setActiveImage(zs.targetImageIndex);
    }
  }

  // -------------------------------------------------------------------
  // Cart property writer — zone-scoped keys + legacy back-compat from
  // the first enabled zone so the order-webhook (Phase 4) keeps parsing
  // until it's updated.
  // -------------------------------------------------------------------
  function writeCartProperties(/* submitEvent */) {
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    clearCartProperties(form);
    let totalAddonCents = 0;
    let firstEnabled = null;
    const zs0 = zoneStates[0];

    if (wisconsinActive() && zs0) {
      // Per-location: ONE group per FILLED location, keyed by the location id
      // (downstream the zone id IS the location id), carrying that location's
      // type and only the fields the type shows.
      const filled = wisconsinFilledLocations();
      const perLocation = locationAddonCents();
      const writeFields = function (prefix, loc) {
        wisconsinFieldsForType(loc.type || wiType).forEach(function (k) {
          const v = loc.values[k];
          if (!v || !String(v).trim()) return;
          const fieldDef = zs0.zone.template.fields.find(f => f.id === k);
          addCartProperty(form, prefix + k, fieldDef && fieldDef.uppercase ? String(v).toUpperCase() : v);
        });
      };
      filled.forEach(function (loc) {
        const id = loc.id;
        addCartProperty(form, '_pers_zone_' + id + '_template', zs0.zone.templateId);
        addCartProperty(form, '_pers_zone_' + id + '_type', loc.type || wiType);
        addCartProperty(form, '_pers_zone_' + id + '_location', id);
        writeFields('_pers_zone_' + id + '_field_', loc);
        addCartProperty(form, '_pers_zone_' + id + '_font', zs0.font);
        addCartProperty(form, '_pers_zone_' + id + '_ink', resolveColor(zs0.inkColor));
        addCartProperty(form, '_pers_zone_' + id + '_addon', (perLocation / 100).toFixed(2));
        totalAddonCents += perLocation;
      });
      if (filled.length) {
        addCartProperty(form, '_personalization_locations', String(filled.length));
        if (totalAddonCents > 0) addCartProperty(form, '_personalization_total_addon', (totalAddonCents / 100).toFixed(2));
        // Legacy flat keys mirror the FIRST filled location.
        const first = filled[0];
        addCartProperty(form, '_personalization_template', zs0.zone.templateId);
        if (window.GHOSTFIT_PRODUCT_CONFIG_ID) addCartProperty(form, '_personalization_config_id', window.GHOSTFIT_PRODUCT_CONFIG_ID);
        addCartProperty(form, '_personalization_type', first.type);
        addCartProperty(form, '_personalization_location', first.id);
        writeFields('_personalization_field_', first);
        addCartProperty(form, '_personalization_font', zs0.font);
        addCartProperty(form, '_personalization_ink_color', resolveColor(zs0.inkColor));
        addCartProperty(form, '_personalization_addon', (perLocation / 100).toFixed(2));
      }
      return;
    }

    for (const zs of zoneStates) {
      if (!zs.enabled || !zoneHasEnteredValues(zs)) continue;
      if (!firstEnabled) firstEnabled = zs;
      const id = zs.zoneId;
      addCartProperty(form, '_pers_zone_' + id + '_template', zs.zone.templateId);
      addCartProperty(form, '_pers_zone_' + id + '_location', id);
      for (const [k, v] of Object.entries(zs.values)) {
        if (!v) continue;
        const fieldDef = zs.zone.template.fields.find(f => f.id === k);
        addCartProperty(form, '_pers_zone_' + id + '_field_' + k, fieldDef && fieldDef.uppercase ? v.toUpperCase() : v);
      }
      addCartProperty(form, '_pers_zone_' + id + '_font', zs.font);
      addCartProperty(form, '_pers_zone_' + id + '_ink', resolveColor(zs.inkColor));
      const addon = zoneAddonCents(zs);
      addCartProperty(form, '_pers_zone_' + id + '_addon', (addon / 100).toFixed(2));
      totalAddonCents += addon;
    }
    const enabledCount = zoneStates.filter(zs => zs.enabled && zoneHasEnteredValues(zs)).length;
    if (enabledCount) addCartProperty(form, '_personalization_locations', String(enabledCount));
    if (totalAddonCents > 0) addCartProperty(form, '_personalization_total_addon', (totalAddonCents / 100).toFixed(2));

    if (firstEnabled) {
      addCartProperty(form, '_personalization_template', firstEnabled.zone.templateId);
      if (window.GHOSTFIT_PRODUCT_CONFIG_ID) addCartProperty(form, '_personalization_config_id', window.GHOSTFIT_PRODUCT_CONFIG_ID);
      for (const [k, v] of Object.entries(firstEnabled.values)) {
        if (!v) continue;
        const fieldDef = firstEnabled.zone.template.fields.find(f => f.id === k);
        addCartProperty(form, '_personalization_field_' + k, fieldDef && fieldDef.uppercase ? v.toUpperCase() : v);
      }
      addCartProperty(form, '_personalization_font', firstEnabled.font);
      addCartProperty(form, '_personalization_ink_color', resolveColor(firstEnabled.inkColor));
      addCartProperty(form, '_personalization_addon', (zoneAddonCents(firstEnabled) / 100).toFixed(2));
    }
  }

  function clearCartProperties(form) {
    form.querySelectorAll('input[name^="properties[_pers"], input[name^="properties[_personalization"]').forEach(function (el) {
      el.parentNode.removeChild(el);
    });
  }
  function addCartProperty(form, name, value) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[' + name + ']';
    input.value = value;
    form.appendChild(input);
  }

  function bindExactPreview() {
    if (!exactPreviewBtn) return;
    // Exact preview only supports single-zone products today. For multi-zone,
    // hide the button — it'd be ambiguous which zone to preview.
    if (isMultiZone) {
      exactPreviewBtn.style.display = 'none';
      return;
    }
    exactPreviewBtn.addEventListener('click', async () => {
      const productConfigId = window.GHOSTFIT_PRODUCT_CONFIG_ID;
      if (!productConfigId) { alert('Preview unavailable — missing product config id'); return; }
      const zs = zoneStates[0];
      const body = {
        productConfigId,
        ...zs.values,
        font: zs.font,
        nameColor: resolveColor(zs.inkColor),
        numberColor: resolveColor(zs.inkColor)
      };
      exactPreviewBtn.disabled = true;
      try {
        const res = await fetch('/apps/gf/api/generate-back-mockup', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        });
        if (res.ok) {
          const blob = await res.blob();
          const url = URL.createObjectURL(blob);
          const original = mainImg.src;
          mainImg.src = url;
          setTimeout(() => { mainImg.src = original; URL.revokeObjectURL(url); }, 3000);
        }
      } finally {
        exactPreviewBtn.disabled = false;
      }
    });
  }

  // -------------------------------------------------------------------
  // Boot
  // -------------------------------------------------------------------
  buildAllCards();
  if (wisconsinActive()) {
    applyWisconsinFieldVisibility();
    applyWisconsinLocationState();
  }
  bindHandlers();
  bindExactPreview();
  renderAllZonesSVG();
  updatePricing();
  applyAllZoneVisibility();

  // Auto-fit measures glyph widths, so a render that ran before the webfonts
  // arrived used fallback metrics — re-render once fonts are ready.
  if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
    document.fonts.ready.then(() => renderAllZonesSVG());
  }
})();
